import React from 'react';
import PropTypes from 'prop-types';

/**
 * ReadOnlyFieldWithJson component displays a label and corresponding data in a read-only format.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.label - The label to display.
 * @param {string|number|React.ReactNode} props.data - The data to display next to the label.
 *
 * @returns {JSX.Element} The rendered read-only field component.
 */
const ReadOnlyFieldWithJson = (props) => {
  const {label, data} = props;
  return (
    <div className='oDP flex flex-row gap-4'>
      <div className='flex'>
        <div className='w100'>
          <div className='ptb'>
            <div className='flex gap-4'>
              <label className='lableColor'>{label}</label>
            </div>
            <div className='flex gap-4'>{data}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

ReadOnlyFieldWithJson.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node
  ])
};

export default React.memo(ReadOnlyFieldWithJson);
